export class DiContainer<
  ProviderTypeImplementationMap extends Record<string, unknown>,
> {
  private implementationMap: Partial<ProviderTypeImplementationMap> = {};
  provide<K extends keyof ProviderTypeImplementationMap>(
    key: K,
    implementation: ProviderTypeImplementationMap[K],
  ) {
    this.implementationMap[key] = implementation;
  }

  inject<K extends keyof ProviderTypeImplementationMap>(
    key: K,
  ): ProviderTypeImplementationMap[K] {
    const impl = this.implementationMap[key];

    if (!impl) {
      throw new Error(`No Provider for ${String(key)}`);
    }

    return impl;
  }

  injectOptional<K extends keyof ProviderTypeImplementationMap>(
    key: K,
  ): ProviderTypeImplementationMap[K] | undefined {
    return this.implementationMap[key];
  }
}
